<div class="grid-day">{{ day.dayOfTheMonth }}</div>
